(() => {
  let _swat;
  let _cache = [];

  // Match by product ID — the card's active variant may differ from the wishlisted one.
  function getCachedItem(empi) {
    return _cache.find((item) => item.empi === empi);
  }

  function updateAllButtons() {
    document.querySelectorAll('.product-block__wishlist-btn').forEach((btn) => {
      const cached = getCachedItem(Number(btn.dataset.empi));
      if (cached) btn.dataset.epi = cached.epi;
      btn.classList.toggle('swym-added', !!cached);
      btn.setAttribute('aria-label', cached ? 'Remove from wishlist' : 'Add to wishlist');
      btn.hidden = false;
    });
  }

  // rs-wishlist.js fetches the wishlist and broadcasts state here
  document.addEventListener('on:wishlist:state', (e) => {
    _cache = (e.detail && e.detail.items) || [];
    updateAllButtons();
  });

  // After filter AJAX swap, re-apply cached state and re-fetch in case cache was cold.
  document.addEventListener('on:filter:after-ajax', () => {
    updateAllButtons();
    document.dispatchEvent(new CustomEvent('on:wishlist:changed'));
  });

  // Event delegation — handles dynamically loaded cards too
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-block__wishlist-btn');
    if (!btn || !_swat) return;
    e.preventDefault();

    const product = {
      epi:  Number(btn.dataset.epi),
      empi: Number(btn.dataset.empi),
      du:   btn.dataset.du,
      dt:   btn.dataset.dt,
      iu:   btn.dataset.iu,
      pr:   Number(btn.dataset.pr),
    };

    if (btn.classList.contains('swym-added')) {
      _swat.removeFromWishList(product, () => {
        btn.classList.remove('swym-added');
        btn.setAttribute('aria-label', 'Add to wishlist');
        document.dispatchEvent(new CustomEvent('on:wishlist:changed'));
      });
    } else {
      _swat.addToWishList(product, () => {
        btn.classList.add('swym-added');
        btn.setAttribute('aria-label', 'Remove from wishlist');
        document.dispatchEvent(new CustomEvent('on:wishlist:changed'));
      });
    }
  });

  // Store swat for click handling; initial state arrives via on:wishlist:state
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push((swat) => { _swat = swat; });
})();
